import ImageListBody from './ImageListBody';

const View = (props) => <ImageListBody {...props} />;

export default View;
